import * as React from 'react';

import {Basic} from './Basic.story';
import {Delay} from './Delay.story';
import {Placement} from './Placement.story';
import {Warmup} from './Warmup.story';

const basic = {
  rendered: <Basic />,
  source: `<Tooltip
  type="description"
  trigger={
    <Button type="primary" disabled onPress={undefined}>
      Pay out to bank
    </Button>
  }
>
  You have no available balance to pay out. You can create payouts when
  you've accumulated a positive balance again.
</Tooltip>

<Tooltip
  type="label"
  trigger={
    <Button onPress={undefined}>
      <Icon name="notifications" />
    </Button>
  }
>
  Notifications
</Tooltip>`,
};

const delay = {
  rendered: <Delay />,
  source: `<Tooltip delay={0} trigger={<Button onPress={undefined}>Immediate</Button>}>
  I showed up immediately.
</Tooltip>`,
};

const placement = {
  rendered: <Placement />,
  source: `<Tooltip placement="top left" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "top left"
</Tooltip>
<Tooltip placement="top" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "top"
</Tooltip>
<Tooltip placement="top right" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "top right"
</Tooltip>
<Tooltip placement="right top" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "right top"
</Tooltip>
<Tooltip placement="right" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "right"
</Tooltip>
<Tooltip placement="right bottom" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "right bottom"
</Tooltip>
<Tooltip placement="bottom right" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "bottom right"
</Tooltip>
<Tooltip placement="bottom" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "bottom"
</Tooltip>
<Tooltip placement="bottom left" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "bottom left"
</Tooltip>
<Tooltip placement="left bottom" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "left bottom"
</Tooltip>
<Tooltip placement="left" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "left"
</Tooltip>
<Tooltip placement="left top" trigger={<Button onPress={undefined}><Icon name="info" /></Button>}>
  "left top"
</Tooltip>`,
};

const warmup = {
  rendered: <Warmup />,
  source: `<Tooltip trigger={<Button onPress={undefined}>Hover me</Button>}>
  I showed up after a delay.
</Tooltip>

<Tooltip trigger={<Button onPress={undefined}>Then me</Button>}>
  I showed up immediately.
</Tooltip>`,
};

export const TooltipExamples = {
  basic,
  delay,
  placement,
  warmup,
};
